<template>
    <div>
        <v-container fluid class="px-2 px-sm-4">
            <v-row justify="center">
                <v-col cols="12" sm="11" md="10" lg="8" xl="6">
                    <v-card class="pa-3 pa-sm-4 pa-md-6">
                        <v-card-title class="text-h5 text-sm-h4 mb-4 text-center">
                            <v-icon large color="primary" class="mr-2">mdi-download</v-icon>
                            {{ $t('troubleshooting.pwa.title') }}
                        </v-card-title>

                        <v-card-text>
                            <div class="text-body-1 mb-6">
                                {{ $t('troubleshooting.pwa.intro') }}
                            </div>

                            <!-- Dispositivo Móvel -->
                            <v-expansion-panels v-model="panel" multiple>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        <v-icon color="primary" class="mr-3">mdi-cellphone</v-icon>
                                        <span class="text-body-1 text-sm-h6">{{ $t('troubleshooting.pwa.mobile.title') }}</span>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-tabs v-model="mobileTab" background-color="transparent" color="primary" grow>
                                            <v-tab>
                                                <v-icon left>mdi-android</v-icon>
                                                <span class="d-none d-sm-inline">{{ $t('troubleshooting.pwa.mobile.android.title') }}</span>
                                            </v-tab>
                                            <v-tab>
                                                <v-icon left>mdi-apple</v-icon>
                                                <span class="d-none d-sm-inline">{{ $t('troubleshooting.pwa.mobile.ios.title') }}</span>
                                            </v-tab>
                                        </v-tabs>

                                        <v-tabs-items v-model="mobileTab">
                                            <!-- Android -->
                                            <v-tab-item>
                                                <v-card flat>
                                                    <v-card-text>
                                                        <div class="text-body-1 mb-4">
                                                            <strong>{{ $t('troubleshooting.pwa.mobile.android.browser.title') }}</strong>
                                                        </div>
                                                        <v-list dense>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-1-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.android.browser.step1') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-2-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.android.browser.step2') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-3-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.android.browser.step3') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-4-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.android.browser.step4') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                        
                                                        <v-divider class="my-4"></v-divider>
                                                        
                                                        <div class="text-body-1 mb-4">
                                                            <strong>{{ $t('troubleshooting.pwa.mobile.android.alternative.title') }}</strong>
                                                        </div>
                                                        <v-list dense>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-1-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.android.alternative.step1') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-2-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.android.alternative.step2') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-card-text>
                                                </v-card>
                                            </v-tab-item>

                                            <!-- iOS -->
                                            <v-tab-item>
                                                <v-card flat>
                                                    <v-card-text>
                                                        <div class="text-body-1 mb-4">
                                                            <strong>{{ $t('troubleshooting.pwa.mobile.ios.safari.title') }}</strong>
                                                        </div>
                                                        <v-list dense>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-1-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.ios.safari.step1') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-2-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.ios.safari.step2') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-3-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.ios.safari.step3') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-4-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.ios.safari.step4') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                        
                                                        <v-divider class="my-4"></v-divider>
                                                        
                                                        <div class="text-body-1 mb-4">
                                                            <strong>{{ $t('troubleshooting.pwa.mobile.ios.otherBrowsers.title') }}</strong>
                                                        </div>
                                                        <v-list dense>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-1-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.ios.otherBrowsers.step1') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-2-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.ios.otherBrowsers.step2') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-3-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.ios.otherBrowsers.step3') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-4-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.ios.otherBrowsers.step4') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                        
                                                        <v-divider class="my-4"></v-divider>
                                                        
                                                        <div class="text-body-1 mb-4">
                                                            <strong>{{ $t('troubleshooting.pwa.mobile.ios.important.title') }}</strong>
                                                        </div>
                                                        <v-list dense>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="warning">mdi-alert-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.ios.important.note1') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="warning">mdi-alert-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.mobile.ios.important.note2') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-card-text>
                                                </v-card>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>

                                <!-- Desktop -->
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        <v-icon color="primary" class="mr-3">mdi-desktop-classic</v-icon>
                                        <span class="text-body-1 text-sm-h6">{{ $t('troubleshooting.pwa.desktop.title') }}</span>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-tabs v-model="desktopTab" background-color="transparent" color="primary" grow>
                                            <v-tab>
                                                <v-icon left>mdi-google-chrome</v-icon>
                                                <span class="d-none d-sm-inline">{{ $t('troubleshooting.pwa.desktop.chrome.title') }}</span>
                                            </v-tab>
                                            <v-tab>
                                                <v-icon left>mdi-firefox</v-icon>
                                                <span class="d-none d-sm-inline">{{ $t('troubleshooting.pwa.desktop.firefox.title') }}</span>
                                            </v-tab>
                                            <v-tab>
                                                <v-icon left>mdi-microsoft-edge</v-icon>
                                                <span class="d-none d-sm-inline">{{ $t('troubleshooting.pwa.desktop.edge.title') }}</span>
                                            </v-tab>
                                        </v-tabs>

                                        <v-tabs-items v-model="desktopTab">
                                            <!-- Chrome -->
                                            <v-tab-item>
                                                <v-card flat>
                                                    <v-card-text>
                                                        <v-list dense>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-1-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.chrome.main.step1') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-2-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.chrome.main.step2') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-3-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.chrome.main.step3') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-4-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.chrome.main.step4') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                        
                                                        <v-divider class="my-4"></v-divider>
                                                        
                                                        <div class="text-body-1 mb-4">
                                                            <strong>{{ $t('troubleshooting.pwa.desktop.chrome.alternative.title') }}</strong>
                                                        </div>
                                                        <v-list dense>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-1-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.chrome.alternative.step1') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-2-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.chrome.alternative.step2') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-3-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.chrome.alternative.step3') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-card-text>
                                                </v-card>
                                            </v-tab-item>

                                            <!-- Firefox -->
                                            <v-tab-item>
                                                <v-card flat>
                                                    <v-card-text>
                                                        <v-list dense>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-1-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.firefox.step1') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-2-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.firefox.step2') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-3-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.firefox.step3') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-4-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.firefox.step4') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-card-text>
                                                </v-card>
                                            </v-tab-item>

                                            <!-- Edge -->
                                            <v-tab-item>
                                                <v-card flat>
                                                    <v-card-text>
                                                        <v-list dense>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-1-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.edge.main.step1') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-2-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.edge.main.step2') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-3-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.edge.main.step3') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-4-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.edge.main.step4') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                        
                                                        <v-divider class="my-4"></v-divider>
                                                        
                                                        <div class="text-body-1 mb-4">
                                                            <strong>{{ $t('troubleshooting.pwa.desktop.edge.alternative.title') }}</strong>
                                                        </div>
                                                        <v-list dense>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-1-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.edge.alternative.step1') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-2-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.edge.alternative.step2') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-icon>
                                                                    <v-icon color="primary">mdi-numeric-3-circle</v-icon>
                                                                </v-list-item-icon>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="text-wrap">{{ $t('troubleshooting.pwa.desktop.edge.alternative.step3') }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-card-text>
                                                </v-card>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>

                            <!-- Benefícios do PWA -->
                            <v-card class="mt-6 pa-3 pa-sm-4" color="success" dark>
                                <v-card-title class="text-body-1 text-sm-h6">
                                    <v-icon left>mdi-star</v-icon>
                                    {{ $t('troubleshooting.pwa.benefits.title') }}
                                </v-card-title>
                                <v-card-text>
                                    <v-list dense dark>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t('troubleshooting.pwa.benefits.benefit1') }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t('troubleshooting.pwa.benefits.benefit2') }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t('troubleshooting.pwa.benefits.benefit3') }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t('troubleshooting.pwa.benefits.benefit4') }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t('troubleshooting.pwa.benefits.benefit5') }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card-text>
                            </v-card>

                            <!-- Dicas Adicionais -->
                            <v-card class="mt-6 pa-3 pa-sm-4" color="info" dark>
                                <v-card-title class="text-body-1 text-sm-h6">
                                    <v-icon left>mdi-lightbulb</v-icon>
                                    {{ $t('troubleshooting.pwa.tips.title') }}
                                </v-card-title>
                                <v-card-text>
                                    <v-list dense dark>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t('troubleshooting.pwa.tips.tip1') }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t('troubleshooting.pwa.tips.tip2') }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t('troubleshooting.pwa.tips.tip3') }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t('troubleshooting.pwa.tips.tip4') }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card-text>
                            </v-card>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'TroubleshootingPWA',
    data: () => ({
        panel: [0], // Abrir primeiro painel por padrão
        mobileTab: 0,
        desktopTab: 0
    })
}
</script>

<style scoped>
.v-expansion-panel-header {
    font-weight: bold;
}

/* Melhorar espaçamento em telas pequenas */
@media (max-width: 600px) {
    .v-card__text {
        padding: 12px !important;
    }
    
    .v-list-item {
        min-height: 48px;
    }
    
    .v-list-item__title {
        font-size: 14px !important;
        line-height: 1.3 !important;
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
    }
    
    .v-list-item__content {
        padding-right: 8px !important;
    }
}

/* Garantir que o conteúdo não seja cortado */
.v-expansion-panel-content__wrap {
    padding: 0 16px 16px 16px;
}

/* Melhorar legibilidade em telas pequenas */
@media (max-width: 480px) {
    .v-card__title {
        font-size: 1.25rem !important;
    }
    
    .text-body-1 {
        font-size: 14px !important;
    }
    
    .v-list-item__title {
        font-size: 13px !important;
        line-height: 1.4 !important;
    }
    
    .v-card__text {
        padding: 8px !important;
    }
}

/* Garantir que o texto não seja cortado em qualquer tela */
.v-list-item__title {
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    hyphens: auto !important;
}

/* Ajustar espaçamento dos ícones em telas pequenas */
@media (max-width: 600px) {
    .v-list-item__icon {
        min-width: 32px !important;
        margin-right: 8px !important;
    }
}

/* Garantir que todos os títulos quebrem linha corretamente */
.v-list-item__title {
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    hyphens: auto !important;
    line-height: 1.4 !important;
    padding-right: 8px !important;
}

/* Garantir que o conteúdo das listas não seja cortado */
.v-list-item {
    align-items: flex-start !important;
}

.v-list-item__content {
    flex: 1 1 auto !important;
    min-width: 0 !important;
    overflow: hidden !important;
}

/* Ajustes específicos para telas muito pequenas */
@media (max-width: 360px) {
    .v-card__text {
        padding: 6px !important;
    }
    
    .v-list-item__title {
        font-size: 12px !important;
        line-height: 1.5 !important;
    }
    
    .v-list-item__icon {
        min-width: 28px !important;
        margin-right: 6px !important;
    }
}
</style> 